export default {
  'menu.console.settings': 'Configuració personal',
  'menu.welcome': 'Benvingut',
  'menu.more-blocks': 'Més blocs',
  'menu.home': 'Pàgina d\'inici',
  'menu.admin': 'Pàgina d\'administració',
  'menu.admin.sub-page': 'Pàgina d\'administració de segon nivell',
  'menu.login': 'Iniciar sessió',
  'menu.register': 'Registrar-se',
  'menu.register-result': 'Resultat del registre',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Pàgina d\'anàlisi',
  'menu.dashboard.monitor': 'Pàgina de monitoratge',
  'menu.dashboard.workplace': 'Espai de treball',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Pàgina de formularis',
  'menu.form.basic-form': 'Formulari bàsic',
  'menu.form.step-form': 'Formulari pas a pas',
  'menu.form.step-form.info': 'Formulari pas a pas (omplir informació de transferència)',
  'menu.form.step-form.confirm': 'Formulari pas a pas (confirmar informació de transferència)',
  'menu.form.step-form.result': 'Formulari pas a pas (completat)',
  'menu.form.advanced-form': 'Formulari avançat',
  'menu.list': 'Pàgina de llistes',
  'menu.list.table-list': 'Taula de consultes',
  'menu.list.basic-list': 'Llista estàndard',
  'menu.list.card-list': 'Llista de targetes',
  'menu.list.search-list': 'Llista de cerca',
  'menu.list.search-list.articles': 'Llista de cerca (articles)',
  'menu.list.search-list.projects': 'Llista de cerca (projectes)',
  'menu.list.search-list.applications': 'Llista de cerca (aplicacions)',
  'menu.profile': 'Pàgina de detalls',
  'menu.profile.basic': 'Pàgina de detalls bàsica',
  'menu.profile.advanced': 'Pàgina de detalls avançada',
  'menu.result': 'Pàgina de resultats',
  'menu.result.success': 'Pàgina d\'èxit',
  'menu.result.fail': 'Pàgina d\'error',
  'menu.exception': 'Pàgina d\'excepció',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Activar error',
  'menu.account': 'Pàgina personal',
  'menu.account.center': 'Centre personal',
  'menu.account.settings': 'Configuració personal',
  'menu.account.trigger': 'Activar error',
  'menu.account.logout': 'Tancar sessió',
  'menu.account.profile': 'Perfil',


  'menu.admin.dashboard': 'Tauler de control',
  'menu.admin.settings': 'Configuració del sistema',
  'menu.admin.providers': 'Proveïdors de models',
  'menu.admin.unbindDevice': 'Desvinculació de dispositius',
  'menu.admin.userManage': 'Gestió d\'usuaris',
  'menu.admin.systemConfig': 'Configuració avançada',
  'menu.admin.whiteList': 'Llista blanca',
  'menu.admin.opsManage': 'Gestió d\'operacions',
  'menu.admin.recorderManage': 'Gestió d\'enregistraments',

  'menu.console': 'Consola',
  'menu.console.agents': 'Agents intel·ligents',
  'menu.console.agentDevice': 'Gestionar dispositius',
  'menu.console.devices': 'Gestió de dispositius',
  'menu.console.speakers': 'Reconeixement de veu',
  'menu.admin.deviceManage': 'Gestió de dispositius',
  'menu.console.voiceClone': 'Clonació de veu',
};
